import { getDecodedID, getEncodedID } from "./encodeAndDecode.utils";

export const getDecodedBudgetId = (id: string) => Number(getDecodedID(id).split(":")[1]);
export const getEncodedBudgetId = (id: string | number) => getEncodedID(`Budget:${id}`);

export const getUserBudgetIdStorageKey = (entitySubdomain: string, userUuid: string) => {
  return `${entitySubdomain}_${userUuid}_user_budget_id`;
};

export const getUserBudgetId = (entitySubdomain: string, userUuid: string) => {
  const encodedBudgetId = localStorage.getItem(getUserBudgetIdStorageKey(entitySubdomain, userUuid));
  return encodedBudgetId ? getDecodedBudgetId(encodedBudgetId) : null;
};

type GetBudgetLinkParams = {
  entitySubdomain: string;
  budgetId: number;
};
export const getBudgetLink = ({ entitySubdomain, budgetId }: GetBudgetLinkParams) => {
  const encodedBudgetId = getEncodedBudgetId(budgetId);
  return `/budgets/${entitySubdomain}/${encodedBudgetId}`;
};
